export const addAcceptedSuggestionDecisions = ({
  confirmedPriorities = [], candidates = [], existingDecisions = [], makeDecision,
}) => {
  const acceptedKeys = new Set(confirmedPriorities.map((item) => item.suggestionKey).filter(Boolean));
  const existingKeys = new Set(existingDecisions.map((item) => item.suggestionKey));
  const additions = candidates
    .filter((candidate) => acceptedKeys.has(candidate.suggestionKey) && !existingKeys.has(candidate.suggestionKey))
    .map((candidate) => makeDecision({
      status: 'accepted', suggestionKey: candidate.suggestionKey, areaId: candidate.areaId,
    }));
  return [...existingDecisions, ...additions];
};

export const upsertSuggestionDecision = ({ existingDecisions = [], candidate, status, makeDecision }) => [
  ...existingDecisions.filter((item) => item.suggestionKey !== candidate.suggestionKey),
  makeDecision({ status, suggestionKey: candidate.suggestionKey, areaId: candidate.areaId }),
];

export const upsertEvidenceDecision = ({ existingDecisions = [], areaId, sourceId, status, makeDecision }) => [
  ...existingDecisions.filter((decision) => !(decision.areaId === areaId && decision.sourceId === sourceId)),
  makeDecision({ status, areaId, sourceId }),
];
